import { SubscriptionType } from '@symon-ai/wisepipe-common';
import { SubscriptionOwnerSystem } from './subscriptionOwnerSystem';
// returns one of Varicent AA, Varicent ELT, Varicent AI, Varicent SP subscriptions or undefined if no varicent subscriptions
export const getSubscriptionType = (subscriptions) => {
    const subscriptionTypes = subscriptions
        ?.filter((subscription) => subscription.subscriptionOwnerSystem === SubscriptionOwnerSystem.Product)
        .map((subscription) => subscription.type) ?? [];
    // Althought unlikely, an org may have more than one subscription applied.
    // Determine governing subscription by checking highest access -> lowest access
    if (subscriptionTypes.includes(SubscriptionType.VaricentAI)) {
        return SubscriptionType.VaricentAI;
    }
    if (subscriptionTypes.includes(SubscriptionType.VaricentELT)) {
        return SubscriptionType.VaricentELT;
    }
    if (subscriptionTypes.includes(SubscriptionType.VaricentAdvantageAnalytics)) {
        return SubscriptionType.VaricentAdvantageAnalytics;
    }
    if (subscriptionTypes.includes(SubscriptionType.VaricentSalesPlanning)) {
        return SubscriptionType.VaricentSalesPlanning;
    }
    if (subscriptionTypes.includes(SubscriptionType.VaricentDesigner)) {
        return SubscriptionType.VaricentDesigner;
    }
    return undefined;
};
//# sourceMappingURL=subscriptionHelper.js.map